module.exports = __webpack_public_path__ + "img/sdk-1-0.661a58d.svg";